import React from "react";
import ReactDOM from "react-dom";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.35)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const cardStyle = {
  width: "min(560px, 92vw)",
  background: "white",
  borderRadius: "14px",
  boxShadow:
    "0 25px 50px -12px rgba(0,0,0,0.25), 0 10px 15px -3px rgba(0,0,0,0.2)",
  padding: "28px 28px 22px 28px",
  textAlign: "center",
};

const titleStyle = {
  fontSize: "20px",
  fontWeight: 700,
  marginTop: "8px",
  marginBottom: "10px",
};

const textStyle = {
  fontSize: "15px",
  color: "#334155",
  lineHeight: 1.5,
};

const btnStyle = {
  marginTop: "18px",
  background: "#16a34a",
  color: "white",
  borderRadius: "10px",
  padding: "10px 18px",
  fontWeight: 700,
  border: 0,
  cursor: "pointer",
};

const iconWrap = (ok) => ({
  width: 64,
  height: 64,
  margin: "0 auto",
  borderRadius: "9999px",
  display: "grid",
  placeItems: "center",
  background: ok ? "rgba(22,163,74,0.1)" : "rgba(220,38,38,0.1)",
  color: ok ? "#16a34a" : "#dc2626",
  fontSize: 30,
});

export default function ModalHost() {
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState({
    type: "success", // success | error | info
    title: "",
    message: "",
    closeText: "Cerrar",
    onClose: null,   // callback opcional
    autoCloseMs: null,
  });

  // API global + listener de eventos
  React.useEffect(() => {
    const api = {
      open: (opts = {}) => {
        setData((d) => ({
          ...d,
          ...opts,
          type: opts.type || d.type,
          closeText: opts.closeText || "Cerrar",
        }));
        setOpen(true);
        if (opts.autoCloseMs && Number(opts.autoCloseMs) > 0) {
          window.setTimeout(() => {
            setOpen(false);
            opts.onClose?.();
          }, Number(opts.autoCloseMs));
        }
      },
      close: () => {
        setOpen(false);
        // dispara el onClose vigente si lo hubiera
        setTimeout(() => data.onClose?.(), 0);
      },
    };
    window.__modal = api;

    const handler = (ev) => api.open(ev.detail || {});
    window.addEventListener("modal:open", handler);

    return () => {
      if (window.__modal === api) window.__modal = undefined;
      window.removeEventListener("modal:open", handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.onClose]);

  if (!open) return null;

  const ok = data.type !== "error";
  const close = () => {
    setOpen(false);
    data.onClose?.();
  };

  const body = (
    <div style={overlayStyle} onClick={close}>
      <div style={cardStyle} onClick={(e) => e.stopPropagation()}>
        <div style={iconWrap(ok)}>{ok ? "●" : "⚠"}</div>
        <div style={titleStyle}>
          {ok ? (data.title || "Operación realizada") : "Warning"}
        </div>
        {data.message ? <div style={textStyle}>{data.message}</div> : null}
        <button style={btnStyle} onClick={close}>
          {data.closeText}
        </button>
      </div>
    </div>
  );

  return ReactDOM.createPortal(body, document.body);
}
